var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(this.year))]),_c('div',{staticStyle:{"background-color":"#707070","height":"0px","width":"40%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }